import client from './index'

const adminGetData = (data) => client['api'].get(`studycourses`, {params: data})
const getforprakrs = (data) => client['api'].get(`getforprakrs`, {params: data})
const getforprakrsDetail = (data, study_course_id) => client['api'].get(`getforprakrs/${study_course_id}`, {params: data})
const getforkrs = (data) => client['api'].get(`getforkrs`, {params: data})
const adminStore = (data) => client['api'].post(`studycourses`, data)
const kaprodiGetData = (data) => client['api'].get(`studycoursesbyprodi`, {params: data})
const prodiGetPilihanData = (data) => client['api'].get(`studycoursesbyprodi/pilihan`, {params: data})
const kaprodiStore = (data) => client['api'].post(`studycoursesbyprodi`, data)
const getAllStudyCourses = () => client['api'].get(`getAllStudyCourses`)
const getAllPiihanStudyCourses = () => client['api'].get(`getAllPiihanStudyCourses`)
const uploadExcel = (data) => client['api'].post(`studycourses/excel`, data, {"Content-Type": "multipart/form-data"})
const update = (data,id) => client['api'].patch(`studycourses/${id}`, data)
const setStatus = (data,id) => client['api'].patch(`studycourses/status/${id}`, data)
const destroy = (id) => client['api'].delete(`studycourses/${id}`)
const toggleStatus = (id) => client['api'].get(`studycourses/${id}`)
const toggleOpenStatus = (id) => client['api'].get(`studycourses/open-status/${id}`)

export {
    getforprakrs,
    getforprakrsDetail,
    getforkrs,
    adminGetData,
    adminStore,
    kaprodiGetData,
    kaprodiStore,
    update,
    destroy,
    setStatus,
    uploadExcel,
    getAllStudyCourses,
    getAllPiihanStudyCourses,
    toggleStatus,
    toggleOpenStatus,
    prodiGetPilihanData
}